var map = {
	"./1_x1.png": 92977,
	"./1_x2.png": 84666,
	"./1_x4.png": 76076,
	"./1_x7.png": 44551,
	"./2_x2.png": 79635,
	"./2_x4.png": 97189,
	"./2_x6.png": 68407,
	"./2_x8.png": 10329,
	"./3_x12.png": 8741,
	"./3_x3.png": 16261,
	"./3_x6.png": 42488,
	"./3_x9.png": 89820,
	"./4_x12.png": 25582,
	"./4_x16.png": 12714,
	"./4_x4.png": 90147,
	"./4_x8.png": 83135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12208;